const styles = {
    infoText: {
        margin: "5px"
    },
    infoIcon: {
        color: "primary.main",
        fontSize: "25px"
    }
}

export default styles;